export const menusReducer = (state = {loading: true, resultmenu: null, menus: null, menu: null, total: 0 } , action) => {
    switch (action.type) {
        case 'MENU_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                menus: action.payload.menus,
                total: action.payload.total
            }
        case 'MENU_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                menu: action.payload
            }
        case 'MENU_ADD_SUCCESS':
            return {
                ...state,
                loading:false,
                menus: [...state.menus, action.payload.menu],
                resultmenu: action.payload.message
            }
        case 'MENU_ADD_DUPLICATED':
            return {
                ...state,
                loading:false,
                resultmenu: action.payload.message
            }
        case 'MENU_EDIT_SUCCESS':
            return {
                ...state,
                loading:false,
                resultmenu: action.payload
            }
        case 'MENU_DELETE_SUCCESS':
            return {
                ...state,
                loading:false,
                resultmenu: action.payload
            }
        case 'MENU_RESET_RESULT':
            return {...state,
                resultmenu: null
            }
        case 'MENU_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'MENU_NOT_LOADING':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

